import { memo } from 'react';
import type { ReactElement } from 'react';
import spinner from 'images/spinner@2x.gif';

function SpinnerIconComponent(): ReactElement {
  return (
    <img
      src={spinner}
      width="24"
      height="24"
      // Ignore the GIF changing when running Chromatic visual diffing.
      // Docs: https://www.chromatic.com/docs/ignoring-elements
      data-chromatic="ignore"
    />
  );
}

export const SpinnerIcon = memo(SpinnerIconComponent);
